import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Certs from "./components/Certs";
import Aos from "aos";
import "aos/dist/aos.css";
export default function App() {
  Aos.init();
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      Aos.refresh();
    }, 500);
  });

  return (
    <main id="/" className="text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About />
      <Certs />
      <Projects />
      <Skills />
      <Contact />
    </main>
  );
}
